module.exports = __webpack_public_path__ + "static/media/recharging-your-battery-large.e529d50b.png";